export const shopModels = [
  {
    name: 'itemInventory',
    collectionPath: 'item_inventories',
    fields: ['id', 'location_id', 'stock'],
    relationships: {
      shopItem: { jsonApi: 'hasOne' },
    },
  },
  {
    name: 'shopBanner',
    collectionPath: 'shop_banners',
    fields: [
      'id',
      'message',
      'scheduled',
      'scheduledStart',
      'scheduledEnd',
      'current',
      'active',
    ],
    relationships: {
      sector: { jsonApi: 'hasOne' },
      shopItemCategory: { jsonApi: 'hasOne', type: 'shopItemCategory' },
    },
  },
  {
    name: 'shopItemCategory',
    collectionPath: 'shop_item_categories',
    fields: [
      'active',
      'activeItems',
      'carousel',
      'description',
      'id',
      'landingPage',
      'name',
      'slug',
      'sortOrder',
    ],
    relationships: {
      shopItems: { jsonApi: 'hasMany', type: 'shopItem' },
      shopItemCategoryImages: {
        jsonApi: 'hasMany',
        type: 'shopItemCategoryImage',
      },
    },
  },
  {
    name: 'shopItemCategoryImage',
    fields: ['carousel', 'messageHeader', 'messageDescription', 'sortOrder',
  'imgType'],
    unformatted: ['imageData'],
  },
  {
    name: 'shopItem',
    undefined: ['weight'],
    collectionPath: 'shop_items',
    fields: [
      'id',
      'active',
      'applyTax',
      'brand',
      'cost',
      'description',
      'forParents',
      'global',
      'inventories',
      'inventory',
      'isCatering',
      'limited',
      'name',
      'options',
      'portion',
      'prepFactor',
      'prepTime',
      'price',
      'quantity',
      'maxQuantity',
      'seasonal',
      'shopApplyTax',
      'slug',
      'special',
      'subscription',
      'subscriptionEnd',
      'subscriptionStart',
      'totalInventory',
    ],
    relationships: {
      inventories: { jsonApi: 'hasMany', type: 'itemInventory' },
      shopItemImages: { jsonApi: 'hasMany', type: 'shopItemImage' },
      shopItemCategories: { jsonApi: 'hasOne', type: 'shopItemCategory' },
    },
  },
  {
    name: 'shopItemImage',
    fields: [
      'sortOrder',
      'imgType',
    ],
    unformatted: ['imageData'],
  },
]
